module.exports = __webpack_public_path__ + "img/headbg.9ad3200b.png";